import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Cache } from 'aws-amplify';
import { withRouter } from 'react-router-dom';
import { Row, Col, Button } from 'react-bootstrap';
import { fetchProjects, 
  fetchTotalProjectHours, 
  fetchTotalProjHoursWeek, 
  getProjectsJSON, 
  fetchProjectByRole, 
  resetTotalProjectHours, 
  resetProjectHoursWeek } from '../../store/actions/projects/projectsActions';
import { DRAFT, REJECTED, WORK_HOURS, WORK_DAYS } from '../../store/actions/timesheet/timesheetActions';
import { refreshReports, generateExportData } from '../../store/actions/reports/reportsActions';
import '../../css/reports.css';
import { MANAGER, PROJECT_SPONSOR } from '../../store/actions/users/usersActions';

import Select from 'react-select';

import moment from 'moment';

import { drawTable, fixedRounding } from '../../common/Utilities';
import PageTitle from '../../common/PageTitle';
import ExportReport from  './ExportReport';

class ProjectRunRate extends Component {

  constructor(props) {
    super(props);

    this.showTable = true;
    this.projectId = '';
    this.projectIDs = [];
    this.userId = Cache.getItem('userId');
  }

  componentDidMount() {
    const filters = {
      project_manager: this.userId,
      is_disabled: 0
    }

    this.props.resetTotalProjectHours();
    this.props.resetProjectHoursWeek();
    this.props.fetchProjects(filters);
    this.props.fetchProjectByRole();
  }

  componentWillUnmount() {
    this.props.refreshReports();

    Cache.removeItem('exportHeaders');
    Cache.removeItem('exportData');
    Cache.removeItem('keyValues');
  }

  displayGenerateButton = () => {
    return (
      <Button 
        className="float-right"
        id={this.buttonId}
        onClick={()=>{
          let filters = {} 
          if (!this.projectId) {
            if(this.roleId === MANAGER){
              filters = {
                project_manager: this.userId,
                is_disabled: 0
              }
            }else{
              filters = {
                project_sponsor: this.userId,
                is_disabled: 0
              }
            }

          }
          else {
            filters = {
              id: this.projectId,
              is_disabled: 0
            }
          }

          this.props.fetchProjects(filters);
          this.showTable = true;
        }}
      >
        Generate Report
      </Button>
    )
  }

  displayProjectDropDown = () => {

    let projectsJSON = this.props.getProjectsJSON({is_disabled: 0});
    if (projectsJSON.length) {
      projectsJSON.unshift({
        key: 0,
        value: 0,
        label: '--SELECT ALL PROJECTS--'
      });
    }

    const selectClass = 'projectSelect';

    return (
      <Col xs={3} sm={3} md={3} lg={3} xl={3}>
        <Select
          className={selectClass}
          classNamePrefix={selectClass}
          size="sm"
          onChange={(selectedOption) => {
            this.projectId = selectedOption.value;
          }}
          options={projectsJSON}
        />
      </Col>
    )
  }

  fetchProjectData = () => {
    const projects = this.props.projects.projects || [];
    if (projects && projects.length) {
      projects.forEach(project => {
        if (!(project.id in this.projectIDs)) {
          this.projectIDs.push(project.id);
          this.props.fetchTotalProjectHours(project.id);
          this.props.fetchTotalProjHoursWeek(project.id);
        }
      });
    }
  }

  displayProjectRunRate = () => {
    let tableData = {}
    tableData.headerClass = "align-center";
    tableData.headers = [
      'Project',
      'Start Date', 
      'End Date', 
      'Total Projected Hours', 
      'Week 1', 
      'Week 2', 
      'Week 3', 
      'Week 4', 
      'Total Booked Hours', 
      'Run Rate', 
      'Projected Hours based on Run Rate', 
      'Remaining Hours',
      'Remaining Chargeable Days', 
      'Project Hours Deficit'
    ];

    let keyValues = [
      'project', 
      'startDate', 
      'endDate', 
      'totalProjectedHours', 
      'week1', 
      'week2',
      'week3', 
      'week4', 
      'totalBookedHours', 
      'runRate', 
      'hoursBasedOnRunRate', 
      'remainingHours', 
      'remChargeableDays', 
      'projectHoursDeficit'
    ];

    tableData.body = [];
    let exportData = [];

    const projects = this.props.projects.projects;
    if (projects && projects.length) {
      projects.forEach(project => {
        const totalProjectHours = this.props.projects.totalProjectHours;
        const projectWeekHours = this.props.projects.projectHoursWeek;
        const budgetHours = +project.budgeted_hours;

        let row = [];

        let actualTimeCharges = "";
        let remainingBudget = "";
        let runRate = "";
        let remainChargeable = "";
        let netHours = "";
        let hoursToComplete = 0;
        let week1 = 0;
        let week2 = 0;
        let week3 = 0;
        let week4 = 0;

        if (Object.keys(totalProjectHours).length 
          && project.id in totalProjectHours 
          && project.id in projectWeekHours) {
          const projectHours = totalProjectHours[project.id];
          const projectHourWeeks = projectWeekHours[project.id];

          actualTimeCharges = fixedRounding(projectHours.filter(charge => charge.status !== REJECTED 
                      && charge.status !== DRAFT)
          .map(charge => charge.total_hours)
          .reduce((a, b) => +a + +b, 0)) || 0;
          remainingBudget = fixedRounding(budgetHours - actualTimeCharges);

          const today = moment();
          if (projectHourWeeks.length) {
            
            //retrieve hours per week inside the project
            let todayWeek = moment(today).isoWeek();
            let projectWeekStart = moment(project.start_date).isoWeek();
            let projectWeekEnd = moment(project.end_date).isoWeek();
            let arrProjHourWeeks = [];
            
            //the project duration crosses a year
            if (projectWeekEnd < projectWeekStart) {
              projectWeekEnd = projectWeekStart + (52 - projectWeekStart) + projectWeekEnd;
            }

            if ((projectWeekEnd - projectWeekStart) > 0) {
              
              let w = 4;
              let x = projectWeekStart;
              let y = projectWeekEnd;
              let consolidatedHoursWeek = 0;    

              if (todayWeek < projectWeekEnd) {
                y = todayWeek;
              }
              //start the retrieving from latest week down to week when the project started
              while(y >= x) {
                let totalHours = 0;
                const weekY = y;
                    
                projectHourWeeks.filter(data => {
                  if (data.status !== REJECTED && data.status !== DRAFT) {
                    return data;
                  }
                  return null;
                }).forEach(hourWeek => {
                  if (hourWeek.week_number === weekY) {
                    totalHours += hourWeek.total_hours;
                  }
                })
    
                //the Week 1 should consolidate past weeks which are not part of 4-weeks window
                if (arrProjHourWeeks.length >= 3) {
                  consolidatedHoursWeek += totalHours;

                  if (x === y) {
                    arrProjHourWeeks.push({
                      colWeek: 1, 
                      weekNum: y, 
                      totalHours:  consolidatedHoursWeek 
                    })
                  }
                }
                else {
                  arrProjHourWeeks.push({
                    colWeek: w, 
                    weekNum: y, 
                    totalHours:  totalHours 
                  })
                }

                w--;
                y--;
              }
            }
            
            arrProjHourWeeks.forEach(item => {
              switch(item.colWeek) {
                case 1: 
                  week1 = item.totalHours;
                  break;
                case 2: 
                  week2 = item.totalHours;
                  break;
                case 3: 
                  week3 = item.totalHours;
                  break;  
                case 4: 
                  week4 = item.totalHours;
                  break; 
                default:
                  break;
              }
            })
          }
        
          //see https://trello.com/c/ShwyYJID/7-project-manager-dashboard for formula
          
          const todayWeekStart = today.startOf('week');
          const projectStartWeekStart = moment(project.start_date).startOf('week');
          const projectEndWeekStart = moment(project.end_date).startOf('week');
          const chargedWeeks = moment(todayWeekStart).diff(moment(projectStartWeekStart), 'weeks') + 1;    
          const totalProjectWeeks = moment(projectEndWeekStart).diff(moment(projectStartWeekStart), 'weeks') + 1; 
          const remainingWeeks = totalProjectWeeks - chargedWeeks;

          runRate = chargedWeeks ? fixedRounding(actualTimeCharges / chargedWeeks) : 0;
          if (+runRate !== 0) {
            remainChargeable = fixedRounding(remainingBudget / runRate);
          } else {
            const hoursPerWeek = WORK_HOURS * WORK_DAYS;
            remainChargeable = fixedRounding(remainingBudget / hoursPerWeek);
          }
          hoursToComplete = fixedRounding(runRate * remainingWeeks);
          netHours = fixedRounding(remainingBudget - hoursToComplete);
        } 

        let exportRow = {}
        row.push(project.project_name);
        row.push(project.start_date);
        row.push(project.end_date);
        row.push(budgetHours);
        row.push(week1);
        row.push(week2);
        row.push(week3);
        row.push(week4);
        row.push(actualTimeCharges);
        row.push(runRate);
        row.push(hoursToComplete);
        row.push(remainingBudget);
        row.push(remainChargeable);
        row.push(netHours);

        Object.assign(exportRow, {[keyValues[0]]: project.project_name});
        Object.assign(exportRow, {[keyValues[1]]: project.start_date});
        Object.assign(exportRow, {[keyValues[2]]: project.end_date});
        Object.assign(exportRow, {[keyValues[3]]: budgetHours});
        Object.assign(exportRow, {[keyValues[4]]: week1});
        Object.assign(exportRow, {[keyValues[5]]: week2});
        Object.assign(exportRow, {[keyValues[6]]: week3});
        Object.assign(exportRow, {[keyValues[7]]: week4});
        Object.assign(exportRow, {[keyValues[8]]: actualTimeCharges});
        Object.assign(exportRow, {[keyValues[9]]: runRate});
        Object.assign(exportRow, {[keyValues[10]]: hoursToComplete});
        Object.assign(exportRow, {[keyValues[11]]: remainingBudget});
        Object.assign(exportRow, {[keyValues[12]]: remainChargeable});
        Object.assign(exportRow, {[keyValues[13]]: netHours});

        tableData.body.push(row);
        exportData.push(exportRow);
      })
    }
    else {
      tableData.body = null;
    }

    this.exportData = exportData;
    this.exportHeaders = tableData.headers;

    return drawTable(tableData, this.showTable);
  }

  generateExportButton = () => {
    if (!this.showTable || !this.exportData || !this.exportHeaders) {
      return '';
    }

    const data = generateExportData(this.exportHeaders, this.exportData);

    return (
      <ExportReport fileName="project_run_rate" data={data} />
    )
  }

  render() {
    if (!this.projectIDs.length) {
      this.fetchProjectData();
    }
    return (
      <React.Fragment>
        <PageTitle pageName="Project Run Rate" />
        <Row className="mt-3">
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <Row>
              <Col xs={9} sm={9} md={9} lg={9} xl={9}>
                { this.displayProjectDropDown() }
              </Col>
              <Col xs={3} sm={3} md={3} lg={3} xl={3} >
                { this.displayGenerateButton() }
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            { this.displayProjectRunRate() }
          </Col>
        </Row>
        <Row>
          <Col>
            { this.generateExportButton() }
          </Col>
        </Row>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state) => ({
  projects: state.projects,
  timesheets: state.timesheets,
  users: state.users, 
  common: state.common 
})

const mapDispatchToProps = (dispatch) => {
  return {
    getProjectsJSON: (...args) => dispatch(getProjectsJSON(...args)),
    fetchProjectByRole: (...args) => dispatch(fetchProjectByRole(...args)),
    fetchProjects: (...args) => dispatch(fetchProjects(...args)),
    fetchTotalProjHoursWeek: (...args) => dispatch(fetchTotalProjHoursWeek(...args)), 
    fetchTotalProjectHours: (...args) => dispatch(fetchTotalProjectHours(...args)),
    refreshReports: () => dispatch(refreshReports()),
    resetTotalProjectHours: () => dispatch(resetTotalProjectHours()),
    resetProjectHoursWeek: () => dispatch(resetProjectHoursWeek()),
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProjectRunRate))